import { useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import { Button } from "../Button";

import * as theme from "./LargeVerticalMenu.css";

const BASE_SPACING = 16;

interface LargeVerticalMenuProps {
    children?: React.ReactNode;
    headerLabel?: string;
    triggerComponent: React.ReactNode;
}

export function LargeVerticalMenu({
    children,
    headerLabel,
    triggerComponent,
}: LargeVerticalMenuProps) {
    const [open, setOpen] = useState(false);

    return (
        <DropdownMenu.Root open={open} onOpenChange={setOpen}>
            <DropdownMenu.Trigger asChild>
                {triggerComponent}
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className={theme.content}
                    collisionPadding={BASE_SPACING}
                    sideOffset={BASE_SPACING}
                >
                    <MenuHeader
                        onCloseClick={() => setOpen(false)}
                        label={headerLabel}
                    />
                    {children}
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
}

interface MenuHeaderProps {
    label?: string;
    onCloseClick: () => void;
}
function MenuHeader({ label, onCloseClick }: MenuHeaderProps) {
    return (
        <div className={theme.menuHeaderRoot}>
            {label && <span className={theme.menuHeaderLabel}>{label}</span>}
            <Button
                onClick={onCloseClick}
                variant="text"
                size="nosize"
                className={theme.menuHeaderButton}
            >
                <CloseOutlined />
            </Button>
        </div>
    );
}
